import { keyBy, partition } from 'lodash'
import type { BaseDataItem, Component, PresetData } from '@wix/thunderbolt-becky-types'
import type { FeatureRefs } from '../cssFeatures.types'
import { createCssCompNode } from '../cssCompNode'
import { isRefArray, isVariantRelation } from '../../utils/variantsUtils'
import { isBreakpointRange } from '../../utils/is'
import type { BpToPresetsCss } from './presets.types'

// TODO: decide on data type
const isPresetDataItem = (presetVariant: BaseDataItem) => {
	if (presetVariant.type === 'PresetData') {
		return true
	}
	if (presetVariant.type.endsWith('.Presets')) {
		return true
	}

	return false
}

const getPresetData = (presetVariant: BaseDataItem) => {
	if (isPresetDataItem(presetVariant)) {
		return {
			presetName: (presetVariant as PresetData).presetName,
			variants: [],
		}
	}
	if (isVariantRelation(presetVariant)) {
		return {
			presetName: (presetVariant.to as PresetData).presetName,
			variants: presetVariant.variants,
		}
	}
}

export const presets = createCssCompNode('presets', 'presets', {
	getDependencies: (component: Component, refs: FeatureRefs<'presets'>) =>
		!!component.builderType && component.presetsQuery
			? {
					compPresets: refs.presetsQuery(component.presetsQuery),
			  }
			: null,

	toViewItem: (component, deps) => {
		if (!deps || !deps.compPresets) {
			return null
		}

		const { compPresets } = deps
		const presetsRefArray = isRefArray(compPresets) ? compPresets.values : [compPresets]

		const presetsAcc: BpToPresetsCss = {}

		return presetsRefArray.reduce((acc: BpToPresetsCss, preset) => {
			const presetData = getPresetData(preset)
			if (!presetData) {
				return acc
			}
			const { presetName, variants } = presetData
			const [[breakpointVariant], variantsWithoutBp] = partition(variants, (variant) =>
				isBreakpointRange(variant)
			)

			const breakpointId = breakpointVariant?.id || 'default'
			acc[breakpointId] = acc[breakpointId] || []
			acc[breakpointId].push({
				presetCss: `--preset: ${presetName}`,
				variants: keyBy(variantsWithoutBp, 'id'),
			})

			return acc
		}, presetsAcc)
	},
})
